class ComponentStickyAtc extends HTMLElement {
  connectedCallback() {
    const atcBtnContainer =
      document.querySelector('#atc-wrapper') ||
      document
        .querySelector('hh-product-bundle-pdp')
        ?.shadowRoot?.querySelector('#purchase-controls')
    if (atcBtnContainer) this.initStickyAtc(atcBtnContainer)
  }

  disconnectedCallback() {
    this.observer.disconnect()
    this.removeEventListener('click', this.initAtcEvent.bind(this))
  }

  initStickyAtc(atcBtnContainer) {
    const options = {
      root: null,
      rootMargin: '-16px 0px -16px',
      threshold: [0, 1],
    }

    this.observer = new IntersectionObserver(
      this.showStickyAtc.bind(this),
      options
    )
    this.observer.observe(atcBtnContainer)
    this.addEventListener('click', this.initAtcEvent.bind(this))
  }

  initAtcEvent() {
    const customEvent = new CustomEvent('sticky:atc', {})
    document.dispatchEvent(customEvent)
  }

  showStickyAtc(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.isVisible) {
        this.classList.remove('active')
        return
      }
      if (
        -entry.boundingClientRect.height > entry.boundingClientRect.top ||
        !entry.isVisible
      ) {
        this.classList.add('active')
      } else {
        this.classList.remove('active')
      }
    })
  }
}

customElements.define('pdp-sticky-atc', ComponentStickyAtc)
